import React from 'react'
import { Alert } from 'antd'

const NOTICE_URL = 'https://orsol.notion.site/38390115bc8680408028ee191c05be49'

export const SERVICE_TERMINATION_NOTICE_HEIGHT = 40

type ServiceTerminationNoticeProps = {
  fixed?: boolean
}

const ServiceTerminationNotice: React.FC<ServiceTerminationNoticeProps> = ({ fixed = false }) => (
  <div
    style={
      fixed
        ? {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            zIndex: 600,
          }
        : undefined
    }
  >
    <Alert
      banner
      type="warning"
      showIcon
      message={
        <>
          【お知らせ】スグニーは2026年6月30日（火）をもちましてサービスを終了いたします。詳しくは
          <a href={NOTICE_URL} target="_blank" rel="noopener noreferrer">
            こちら
          </a>
          {' →'}
        </>
      }
    />
  </div>
)

export default ServiceTerminationNotice
